import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { blogsAPI } from '../services/api';
import './Users.css';

const Blogs = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBlogs();
  }, []);

  const loadBlogs = async () => {
    setLoading(true);
    try {
      const response = await blogsAPI.getAll();
      const list = response.data?.blogs || [];
      setBlogs(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error('Error loading blogs:', error);
      toast.error('Error loading blogs: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this blog post?')) return;
    try {
      await blogsAPI.delete(id);
      loadBlogs();
      toast.success('Blog post deleted');
    } catch (error) {
      toast.error('Error deleting: ' + (error.response?.data?.message || error.message));
    }
  };

  if (loading && blogs.length === 0) {
    return <div className="loading">Loading blog posts…</div>;
  }

  return (
    <div className="users-container">
      <div style={{ marginBottom: '20px' }}>
        <Link to="/blogs/new" className="btn btn-primary" style={{ display: 'inline-block' }}>
          + New post
        </Link>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Slug</th>
              <th>Published</th>
              <th>Sort</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!loading && blogs.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                  No blog posts yet
                </td>
              </tr>
            ) : (
              blogs.map((b) => (
                <tr key={b.id}>
                  <td>{b.title || '—'}</td>
                  <td>
                    <code style={{ fontSize: 12 }}>{b.slug}</code>
                  </td>
                  <td>{b.is_published ? 'Yes' : 'No'}</td>
                  <td>{b.sort_order ?? 0}</td>
                  <td className="actions">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => navigate(`/blogs/${b.id}/edit`)}
                    >
                      Edit
                    </button>
                    <button type="button" className="btn btn-danger" onClick={() => handleDelete(b.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Blogs;
